/* eslint-disable no-nested-ternary */
/* eslint-disable class-methods-use-this */
import React, { Component } from 'react';
import { isClient } from 'frontend/helpers/ssr-helper';
import { withTranslation } from 'react-i18next';
import PanelPrincipal from './detalle-amichi/paquete-detalle-panel-comprar/paquete-detalle-panel-comprar';
import Transporte from './detalle-amichi/paquete-detalle-transporte/paquete-detalle-transporte';
import ServiciosIncluidos from './detalle-carga-manual/servicios-incluidos/servicios-incluidos';
import Hoteles from './detalle-carga-manual/paquete-detalle-hoteles/paquete-detalle-hoteles';
import VacacionesAMedida from './paquete-detalle-vacaciones-medida/paquete-detalle-vacaciones-medida';
import PanelOperador from './panel-operador/panel-operador';
import Incluye from './detalle-amichi/paquete-detalle-incluye/paquete-detalle-incluye';
import paquetesClient from '../../api/paquetes';
import SeccionConTitulo from './seccion-detalle/seccion-con-titulo';
import commons from '../../commons/commons';
import PanelBasico from './panel-basico/panel-basico';

class DetalleAmichi extends Component {
  constructor(props) {
    super(props);
    this.validateAvailability = this.validateAvailability.bind(this);
  }

  validateAvailability(e) {
    e.preventDefault();
    this.props.setPreloader(true);
    const url = this.armarUrl();
    const data = {
      idProveedor: url.searchParams.get('p'),
      IdSalida: url.searchParams.get('t'),
      distribucion: url.searchParams.get('h'),
    };
    paquetesClient.validarCuposAmichi(data)
      .then((hasAvailability) => {
        if (hasAvailability.data) {
          if (isClient) {
            window.location.href = `${process.env.RAZZLE_URL_PATH}/checkout?t=${this.props.referencia}&h=${this.props.distribucion}&p=${this.props.paquete.proveedorId}`;
          }
        } else {
          // eslint-disable-next-line no-alert
          alert('Se agotaron los cupos para esta salida, deja tu consulta asi podremos ayudarte');
          if (isClient) {
            window.location.href = `${process.env.RAZZLE_URL_PATH}/consulta?type=PaqueteAMedida&referencia=${this.props.referencia}&proveedorId=10`;
          }
        }
      }).catch((Exception) => {
        // eslint-disable-next-line no-console
        console.error(Exception);
      });
  }

  armarUrl() {
    const urlString = isClient ? window.location.href : '';
    return new URL(urlString);
  }

  render() {
    const { transporte } = this.props.paquete.salidas[0];
    const transporteIsValid = (
      transporte.transporteAereo !== null
      && transporte.transporteAereo.itinerarioVuelo !== null
      && transporte.transporteAereo.itinerarioVuelo !== null
      && transporte.transporteAereo.itinerarioVuelo.informeIda.segmentoPrincipal.fechaLlegada !== '0001-01-01T00:00:00'
      && transporte.transporteAereo.itinerarioVuelo.informeIda.segmentoPrincipal.fechaLlegada !== '0001-01-01T00:00:00'
      && transporte.transporteAereo.itinerarioVuelo.informeVuelta.segmentoPrincipal.fechaSalida !== '0001-01-01T00:00:00'
      && transporte.transporteAereo.itinerarioVuelo.informeVuelta.segmentoPrincipal.fechaLlegada !== '0001-01-01T00:00:00'
    );
    const { cantidadPasajeros, paquete, t } = this.props;

    const precioUnitario = commons.precioUnitario(paquete.salidas[0].precios, cantidadPasajeros);
    const precioUnitarioFormateado = commons.numberFixedToMoney(precioUnitario, 0);

    return (
      <React.Fragment>
        <div className='listado-paquetes'>
          <div className='detalle paquete'>
            <PanelPrincipal
              precioUnitarioFormateado={precioUnitarioFormateado}
              proveedorId={this.props.proveedorId}
              distribucion={this.props.distribucion}
              paquete={this.props.paquete}
              referencia={this.props.referencia}
              cantidadPasajeros={this.props.cantidadPasajeros}
              validateAvailability={this.validateAvailability}
            />

            <div className='container'>
              <br />
              <br />
              {this.props.paquete.salidas[0].servicios.length > 0 ? (
                <SeccionConTitulo titulo={t('layout:packages.details.services')}>
                  <ServiciosIncluidos
                    descripcion={this.props.paquete.salidas[0].servicios}
                    iconos={this.props.paquete.salidas[0].tipoServicios}
                  />
                </SeccionConTitulo>
              )
                : ''}
              {transporteIsValid && (
                <SeccionConTitulo titulo={t('layout:packages.details.transport')}>
                  <Transporte
                    transporte={this.props.paquete.salidas[0].transporte}
                    ida={this.props.paquete.salidas[0].transporte.transporteAereo.itinerarioVuelo.informeIda}
                    vuelta={this.props.paquete.salidas[0].transporte.transporteAereo.itinerarioVuelo.informeVuelta}
                  />
                </SeccionConTitulo>
              )}

              {this.props.paquete.salidas[0].hoteles.length > 0 && (
                <SeccionConTitulo titulo={t('layout:packages.details.lodging')}>
                  <Hoteles
                    destinos={this.props.paquete.salidas[0].destinosHoteles}
                    hoteles={this.props.paquete.salidas[0].hoteles}
                  />
                </SeccionConTitulo>
              )}
              {this.props.paquete.metaDescripcion !== null && (
                <SeccionConTitulo titulo={t('layout:packages.details.description')}>
                  <PanelBasico
                    contenido={<Incluye descripcion={this.props.paquete.metaDescripcion} />}
                  />
                </SeccionConTitulo>
              )}
              <SeccionConTitulo>
                <VacacionesAMedida
                  referencia={this.props.referencia}
                  proveedorId={this.props.proveedorId}
                  destino={this.props.paquete.salidas[0].destinoIata}
                  fechaSalida={this.props.paquete.salidas[0].fechaSalida}
                  cantidadNoches={this.props.paquete.cantNoches}
                />
              </SeccionConTitulo>
              <SeccionConTitulo>
                <PanelOperador
                  datos={this.props.paquete.operadorResponsable}
                />
              </SeccionConTitulo>
            </div>
          </div>
          <div className='clearfix' />
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(DetalleAmichi);
